import React from 'react'
import PropTypes from 'prop-types'

import { FormattedMessage } from 'react-intl'

import defaultMessages from '../locales/en'


const IntlText = ({ id, string, ...others }) => (
    defaultMessages[id] ? (
        <FormattedMessage
            id={id}
            defaultMessage={defaultMessages[id]}
            {...others}
        />
    ) : (
        <span>{id}</span>
    )
)

IntlText.propTypes = {
    id: PropTypes.string.isRequired,
    string: PropTypes.bool
}

IntlText.defaultProps = {
    string: false
}

export default IntlText
